<template>
  <div class="md-layout-item md-size-100 expand">
    <label @click="expand = !expand" class="pointer">{{ label }}</label>
    <md-icon @click.native="expand = !expand" class="pointer">{{ expandIcon }}</md-icon>
  </div>
</template>

<script>
export default {
  name: 'Expand',
  props: ['label', 'group'],
  data: () => ({
    expand: false
  }),
  computed: {
    expandIcon: function () {
      this.$emit('expand', this.group, this.expand)
      return this.expand === true ? 'expand_less' : 'expand_more'
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '@/assets/style/arcadia_theme.scss';

  .expand {
    margin-bottom: 10px !important;
    margin-top: 0;
    label {
      cursor: pointer;
      margin-bottom: 0 !important;
      font-weight: bold;
      color: var(--md-primary) !important;
    }
    i {
      cursor: pointer;
      color: var(--md-primary) !important;
    }
  }
</style>
